import { ITranslationEntry } from '../lang';

export const NE: ITranslationEntry = {
  translations: {
    notifications: 'सूचनाहरू',
    markAllAsRead: 'सबै पढेको रूपमा चिन्ह लगाउनुहोस्',
    poweredBy: 'द्वारा संचालित',
    settings: 'सेटिङहरू',
  },
  lang: 'ne',
};
